var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    fillRule: "evenodd",
    d: "M10 13c-1.105 0-2 .895-2 2v10.257c0 1.104.895 2 2 2h3v-6.638c0-.552.448-1 1-1h4c.552 0 1 .448 1 1v6.638h3c1.105 0 2-.896 2-2V15c0-1.105-.895-2-2-2H10z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M26.367 16H5.633c-1.883 0-2.722-2.365-1.261-3.552l10.367-8.423c.735-.597 1.787-.597 2.522 0l10.367 8.423C29.089 13.635 28.25 16 26.367 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.0376d78994f4ff9234f123602fd875c6.svg";
export { ForwardRef as ReactComponent };